import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const PostWorkoutIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 44 44" {...props}>
      <path
        d="M21.6667 44.0001C33.6328 44.0001 43.3333 34.2996 43.3333 22.3334C43.3333 10.3672 33.6328 0.666748 21.6667 0.666748C9.7005 0.666748 0 10.3672 0 22.3334C0 34.2996 9.7005 44.0001 21.6667 44.0001Z"
        fill="#A8CAFF"
      />
      <path
        d="M24.8817 8.66687C25.7812 8.66687 26.5103 9.39606 26.5103 10.2955V13.72H13.877V10.2955C13.877 9.39606 14.6061 8.66687 15.5056 8.66687H24.8817Z"
        fill="#FF7373"
      />
      <path
        d="M23.8652 13.7198V11.193C23.8652 10.9649 24.0501 10.78 24.2782 10.78C24.5062 10.78 24.6911 10.9649 24.6911 11.193V13.7198H23.8652Z"
        fill="#E05E5E"
      />
      <path
        d="M21.334 13.7198V11.193C21.334 10.9649 21.5189 10.78 21.7469 10.78C21.975 10.78 22.1599 10.9649 22.1599 11.193V13.7198H21.334Z"
        fill="#E05E5E"
      />
      <path
        d="M12.6821 35.9706C11.3853 35.9706 10.334 34.9193 10.334 33.6225V15.7675C10.334 14.4707 11.3853 13.4194 12.6821 13.4194H27.7034C29.0002 13.4194 30.0516 14.4707 30.0516 15.7675V35.9706H12.6821Z"
        fill="white"
      />
      <path
        d="M27.7036 13.4194H25.8867C27.1836 13.4194 28.2349 14.4706 28.2349 15.7675V35.9705H30.0517V15.7675C30.0517 14.4707 29.0004 13.4194 27.7036 13.4194Z"
        fill="#D3D5E0"
      />
      <path
        d="M30.0515 19.9235H10.334V28.0169H30.0515V19.9235Z"
        fill="#FF7373"
      />
      <path
        d="M30.0512 19.9235H28.2344V28.0169H30.0512V19.9235Z"
        fill="#E05E5E"
      />
      <path
        d="M36.8573 26.2619C35.7785 25.1831 34.0296 25.1831 32.9508 26.2619L27.9282 31.2845C26.8495 32.3633 26.8495 34.1122 27.9282 35.191C29.007 36.2697 30.7559 36.2697 31.8347 35.191L36.8573 30.1684C37.9361 29.0896 37.9361 27.3406 36.8573 26.2619Z"
        fill="#FF7373"
      />
      <path
        d="M36.8589 26.2618C36.085 25.4879 34.9661 25.2693 33.9972 25.6058C34.3788 25.7384 34.7372 25.957 35.042 26.2618C36.1208 27.3405 36.1208 29.0895 35.042 30.1683L30.0194 35.1909C29.7146 35.4957 29.3562 35.7143 28.9746 35.8468C29.9435 36.1834 31.0624 35.9648 31.8363 35.1909L36.8589 30.1683C37.9377 29.0895 37.9377 27.3405 36.8589 26.2618Z"
        fill="#E05E5E"
      />
      <path
        d="M20.1934 30.3383C23.7358 30.3383 26.6075 27.4666 26.6075 23.9242C26.6075 20.3818 23.7358 17.5101 20.1934 17.5101C16.651 17.5101 13.7793 20.3818 13.7793 23.9242C13.7793 27.4666 16.651 30.3383 20.1934 30.3383Z"
        fill="#5E6478"
      />
      <path
        d="M20.1935 17.5097C19.9892 17.5097 19.7873 17.5197 19.5879 17.5384C22.8462 17.8436 25.3964 20.5857 25.3964 23.9238C25.3964 27.2619 22.8462 30.004 19.5879 30.3092C19.7873 30.3279 19.9892 30.3379 20.1935 30.3379C23.7359 30.3379 26.6076 27.4662 26.6076 23.9238C26.6076 20.3814 23.7359 17.5097 20.1935 17.5097Z"
        fill="#4C5061"
      />
      <path
        d="M22.6714 22.8433L20.5436 22.8298C20.437 22.8291 20.3546 22.7359 20.3672 22.63L20.6541 20.2178C20.6763 20.0316 20.4332 19.9412 20.3284 20.0968L17.564 24.1987C17.4839 24.3176 17.5694 24.4778 17.7128 24.4774L19.6643 24.4718C19.7763 24.4715 19.861 24.573 19.8406 24.6831L19.3103 27.5519C19.2753 27.741 19.5226 27.8444 19.6327 27.6867L22.8169 23.1244C22.8993 23.0064 22.8153 22.8442 22.6714 22.8433Z"
        fill="#F9C032"
      />
      <path
        d="M36.8592 26.262C35.7804 25.1833 34.0315 25.1833 32.9527 26.262L30.4414 28.7733L34.3479 32.6798L36.8592 30.1685C37.938 29.0897 37.938 27.3408 36.8592 26.262Z"
        fill="white"
      />
      <path
        d="M36.8573 26.2619C36.0833 25.488 34.9645 25.2694 33.9956 25.606C34.3772 25.7385 34.7356 25.9571 35.0404 26.2619C36.1192 27.3407 36.1192 29.0896 35.0404 30.1684L33.4375 31.7712L34.3459 32.6797L36.8572 30.1684C37.936 29.0896 37.936 27.3407 36.8573 26.2619Z"
        fill="#D3D5E0"
      />
    </SvgIcon>
  );
};

export default PostWorkoutIcon;
